<template>
  <b-container fluid class="container-flex">
    
    <app-menu></app-menu>    
    
    <transition name="fade" mode="out-in">
      <router-view ></router-view>
    </transition>    
    <button v-if="updateExists" @click="refreshApp">
      Nova versió disponible! Clica per actualitzar / ¡Nueva versión disponible! Haz clic para actualizar
    </button>
    
        
    
  </b-container>
</template>

<script>
import Menu from './components/Menu.vue';
export default {
  data(){
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },
  components: {
    appMenu: Menu
  },
  methods:{
    showRefreshUI (e) {
      this.registration = e.detail;
      this.updateExists = true;
    },
    refreshApp () {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) { return; }
      this.registration.waiting.postMessage('skipWaiting');
    },

  },
  created(){
    document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true }
    ); 
    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        if (this.refreshing) return;
          this.refreshing = true;
        window.location.reload();
      }
    );
  }
}
</script>


<style>

  html,body{
    height: 100%;
  }

  .container-flex{
    display: flex;
    flex-flow: column;
    height: 100%;
  }

  .container-fluid {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
    background:#4e74e0;
    height: 100%;
    padding-left: 0px;
    padding-right: 0px;
    position: relative;
  }

  .slide-body {
    min-height: 80%;
    height:auto !important;
    display: flex;  
    align-items: center;
    margin-left: 0px;
    margin-right: 0px;
    flex-grow:1
  }
  
  /* If the screen size is Desktop */
  h1{
    font-size: 70px;
  }
  h2{
    font-size: 50px;
  }
  h3{
    font-size: 40px;
  }  
  h4{
    font-size: 30px;
  }
  h5{
    font-size: 30px;
  }
  h6{
    font-size: 30px;
  }
  p {
    font-size: 30px;
  }
  

  /* If the screen size is Laptop */
  @media screen and (max-width: 1920px) {
    h1{
      font-size: 45px;
    }
    h2{
      font-size: 38px;
    }
    h3{
      font-size: 27px;
    }
    h4{
      font-size: 30px;
    }
    h5{
      font-size: 24px;
    }
    h6{
      font-size: 20px;
    }
    p {
      font-size: 25px;
    }
  }

  /* If the screen size is Tablet */
  @media screen and (max-width: 900px) {
    h2{
      font-size: 25px;
    }
    h3{
      font-size: 25px;
    }
    h4{
      font-size: 30px;
    }
    h5{
      font-size: 15px;
    }
    h6{
      font-size: 10px;
    }
    p {
      font-size: 20px;
    }
  }

  /* If the screen size is Mobile */
  @media screen and (max-width: 450px) {
    h2{
      font-size: 30px;
    }
    h3{
      font-size: 25px;
    }
    h4{
      font-size: 20px;
    }
    h5{
      font-size: 15px;
    }
    p {
      font-size: 20px;
    }
  }

  .fade-enter-active{
    animation: fade-in 0.5s ease-out forwards;
  }

  .fade-leave-active{
    animation: fade-out 0.5s ease-out forwards;
  }

  @keyframes fade-in{
    from{    
      opacity: 0;
    }to{    
      opacity: 1;
    }
  }

  @keyframes fade-out{
    from{
      opacity: 1;
    }to{
        opacity: 0;
    }
  }

  #footer{        
    bottom: 2%;
    width: 100%;    
    padding-left: 0px;
    padding-right: 0px;
    position: absolute;
  }

</style>
